import { useState, useEffect, useCallback } from 'react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import AlertTitle from '@mui/material/AlertTitle';

import { checkConfigVersion } from '../utils/checkversion';

type UpdateInfo = {
  reload: () => void;
};

export function UpdateAvailableSnackbar() {
  const [update, setUpdate] = useState<UpdateInfo | null>(null);

  useEffect(() => {
    checkConfigVersion(({ reload }) => {
      setUpdate({ reload });
    });
  }, []);

  const handleRefresh = useCallback(() => {
    if (update) update.reload();
  }, [update]);

  if (!update) return null;

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        severity="warning"
        variant="filled"
        sx={{ width: '100%', alignItems: 'center' }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={handleRefresh}
            sx={{ fontWeight: 600 }}
          >
            Refresh
          </Button>
        }
      >
        <AlertTitle sx={{ mb: 0.5 }}>New version available</AlertTitle>
        A newer version has been deployed. Refresh to get the latest updates.
      </Alert>
    </Snackbar>
  );
}